import React from "react";
import { connect } from "react-redux";
import Formsy from "formsy-react";
import axios from "axios";

import { BASE_URL } from "../../../config";

import { Button, Checkbox, Col, FormControl, Glyphicon, Modal, Row } from "react-bootstrap";
import Select from "react-select";

import { deleteBranch, hideRestaurantModal } from "../restaurantDetails.actions";
import { addRestaurantByApi, updateRestaurantByApi } from "../../Restaurant/restaurant.actions";
import CollapseList from "./CollapseList";
import BranchList from "./BranchList";
import RadioGroup from "../../../components/common/elements/RadioGroup";
import FormInput from "../../../components/common/elements/FormInput";
import translator from "../../../components/localization/translator";
import restaurantConf from "../../../config/restaurant";
import security from "../../../components/common/security/security";
import {
    B2B_SERVICE_HINTS,
    COMPANY,
    INCOME_SOURCE,
    PERCENTAGE_MEASUREMENTS,
    RESTAURANT_COOPERATION_METHODS,
    RESTAURANT_COOPERATION_TYPES,
    RESTAURANT_PAYERS,
    RESTAURANT_SOURCE_OF_INCOME,
    RESTAURANT_TYPES,
    USER_ROLES,
} from "../../../config/constants";

import commonInformation from "./commonInformation";
import BranchDetails from "./BranchDetails";

class RestaurantDetails extends commonInformation {
    constructor(props) {
        super(props);
        this.state = {
            isDisabled: true,
            showBranchDetailsModal: false,
            branch: null,
            branchIndex: null,
            jksFile: null,
            certPassword: "",
            forceJksReplace: false,
            hasJksAttached: false,
        };

        this.restaurantDetails = JSON.parse(
            JSON.stringify(this.props.restaurantDetails || {}),
        );
        // Ensure nested structures exist to avoid "Cannot read properties of undefined" in renderModalBody
        if (!this.restaurantDetails.restaurantInformation) this.restaurantDetails.restaurantInformation = {};
        if (!this.restaurantDetails.restaurantInformation.location) this.restaurantDetails.restaurantInformation.location = { address: "", addressEn: "", addressRu: "", coordinates: { lat: "", lng: "" } };
        if (!this.restaurantDetails.restaurantInformation.location.coordinates) this.restaurantDetails.restaurantInformation.location.coordinates = { lat: "", lng: "" };
        this.changedData = {};
        this.isNew = false;
        this.enableButton = this.enableButton.bind(this);
        this.disableButton = this.disableButton.bind(this);
        this.renderBranchList = this.renderBranchList.bind(this);
        this.form = null;
        this.jksInputRef = React.createRef();
    }

    componentWillReceiveProps(nextProps) {
        const isOpen =
            !this.props.restaurantDetails?.show &&
            nextProps.restaurantDetails?.show;
        this.restaurantDetails =
            isOpen || !Object.keys(this.restaurantDetails || {}).length
                ? JSON.parse(JSON.stringify(nextProps.restaurantDetails || {}))
                : this.restaurantDetails;
        if (!this.restaurantDetails.restaurantInformation) this.restaurantDetails.restaurantInformation = {};
        if (!this.restaurantDetails.restaurantInformation.location) this.restaurantDetails.restaurantInformation.location = { address: "", addressEn: "", addressRu: "", coordinates: { lat: "", lng: "" } };
        if (!this.restaurantDetails.restaurantInformation.location.coordinates) this.restaurantDetails.restaurantInformation.location.coordinates = { lat: "", lng: "" };
    }

    handleBranchEdit(branch, branchIndex) {
        this.setState({
            showBranchDetailsModal: true,
            branch,
            branchIndex,
        });
    }

    closeBranchDetailsModal() {
        this.setState({
            showBranchDetailsModal: false,
            branch: null,
            branchIndex: null,
        });
    }

    resetBranchDetails() {
        this.restaurantDetails.branches = this.restaurantDetails.branches.map(
            (branch) => {
                if (
                    this.state.branch._id &&
                    branch._id === this.state.branch._id
                ) {
                    const prevBranch =
                        this.props.restaurantDetails.branches.find(
                            (br) => br._id === this.state.branch._id,
                        );
                    return prevBranch
                        ? JSON.parse(JSON.stringify(prevBranch))
                        : this.state.branch;
                }

                return branch;
            },
        );
        this.restaurantDetails.branches =
            this.restaurantDetails.branches.filter((branch) => branch._id);
        this.closeBranchDetailsModal();
    }

    setFormRef = (ref) => {
        this.form = ref;
    };

    getRestaurantData() {
        const restaurantColumns = restaurantConf.restaurantEdit;
        const restaurantData = {};
        for (let i = 0, len = restaurantColumns.length; i < len; i++) {
            if (this.restaurantDetails.hasOwnProperty(restaurantColumns[i])) {
                if (restaurantColumns[i] === "restaurantInformation") {
                    // Create a copy of restaurantInformation
                    const restaurantInfo = { ...this.restaurantDetails.restaurantInformation };

                    // Remove empty region names
                    if (!restaurantInfo.regionName || restaurantInfo.regionName.trim() === "") {
                        delete restaurantInfo.regionName;
                    }
                    if (!restaurantInfo.regionNameEn || restaurantInfo.regionNameEn.trim() === "") {
                        delete restaurantInfo.regionNameEn;
                    }
                    if (!restaurantInfo.regionNameRu || restaurantInfo.regionNameRu.trim() === "") {
                        delete restaurantInfo.regionNameRu;
                    }

                    restaurantData[restaurantColumns[i]] = restaurantInfo;
                } else {
                    restaurantData[restaurantColumns[i]] =
                        this.restaurantDetails[restaurantColumns[i]];
                }
            }
        }
        return restaurantData;
    }

    getSavePayload() {
        const restaurant = this.getRestaurantData();
        const { jksFile, certPassword } = this.state;

        // Use only notifyPrincipalAccount
        const notifVal = this.restaurantDetails.notifyPrincipalAccount;
        if (typeof notifVal !== "undefined") {
            restaurant.notifyPrincipalAccount = !!notifVal;
        }

        const form = new FormData();

        // Prepare the data payload
        const payload = {
            ...restaurant,
            ...(jksFile && {
                certPassword: certPassword || "",
            }),
        };

        // Append all restaurant data as a single JSON string
        form.append("data", JSON.stringify(payload));

        // Append the certificate file if it exists
        if (jksFile) {
            form.append("certificate", jksFile);
        }

        return form;
    }

    save() {
        const payload = this.getSavePayload();
        const promise = this.isNew
            ? this.props.addRestaurantByApi(payload)
            : this.props.updateRestaurantByApi(
                this.props.restaurantDetails._id,
                payload,
              );
        if (promise) {
            promise.then(() => this.cancel()).catch(() => {
                // Revert cooperationType.requireReceiptPhoto to last saved value on failure (e.g., 403 for non-SuperAdmin)
                if (!this.restaurantDetails.cooperationType) {
                    this.restaurantDetails.cooperationType = {};
                }
                this.restaurantDetails.cooperationType.requireReceiptPhoto = !!this.props.restaurantDetails.cooperationType?.requireReceiptPhoto;
                this.restaurantDetails.notifyPrincipalAccount = !!this.props.restaurantDetails.notifyPrincipalAccount;

                const orig = this.props.restaurantDetails.cooperationType?.requireReceiptPhoto;
                this.restaurantDetails.cooperationType.requireReceiptPhoto = orig === true || orig === false ? orig : null;
                this.forceUpdate();
            });
        } else {
            this.cancel();
        }
    }

    handleValidSubmit() {
        const promise = this.isNew
            ? this.props.addRestaurantByApi(this.getSavePayload())
            : this.props.updateRestaurantByApi(
                this.props.restaurantDetails._id,
                this.getSavePayload(),
              );
        if (promise) {
            promise.then(() => this.cancel()).catch(() => {
                // Revert cooperationType.requireReceiptPhoto to last saved value on failure (e.g., 403 for non-SuperAdmin)
                if (!this.restaurantDetails.cooperationType) {
                    this.restaurantDetails.cooperationType = {};
                }
                this.restaurantDetails.cooperationType.requireReceiptPhoto = !!this.props.restaurantDetails.cooperationType?.requireReceiptPhoto;
                this.restaurantDetails.notifyPrincipalAccount = !!(this.props.restaurantDetails.notifyPrincipalAccount);

                const orig = this.props.restaurantDetails.cooperationType?.requireReceiptPhoto;
                this.restaurantDetails.cooperationType.requireReceiptPhoto = orig === true || orig === false ? orig : null;
                this.forceUpdate();
            });
        } else {
            this.cancel();
        }
    }

    cancel() {
        this.changedData = {};
        this.setState({ jksFile: null, certPassword: "", forceJksReplace: false });
        this.props.hideRestaurantModal();
    }

    getDistrict() {
        const restaurantInformation =
            this.restaurantDetails && this.restaurantDetails.restaurantInformation;

        if (!restaurantInformation || !restaurantInformation.location) {
            return;
        }

        const coordinates = restaurantInformation.location.coordinates || {};
        const { lat, lng } = coordinates;

        if (!lat || !lng) {
            return;
        }

        axios.get(`${BASE_URL}district`, {
            params: { lat, lng },
        })
            .then((response) => {
                if (!response || !response.data) {
                    return;
                }

                const district = response.data;

                restaurantInformation.regionName = district.name;
                restaurantInformation.regionNameEn = district.nameEn;
                restaurantInformation.regionNameRu = district.nameRu;

                this.forceUpdate();
            })
            .catch(() => {
            });
    }

    validateCoordinates() {
        const restaurantInformation = this.restaurantDetails?.restaurantInformation || {};
        const coordinates =
            restaurantInformation.location &&
            restaurantInformation.location.coordinates
                ? restaurantInformation.location.coordinates
                : {};

        // District/region is NOT required for saving; only coordinates are.
        return !!(coordinates.lat && coordinates.lng);
    }

    renderFooter() {
        return (
            <Modal.Footer>
                <Row>
                    <Col xs={6}>
                        <Button block onClick={this.cancel.bind(this)}>
                            {translator.translate("_cancel_")}
                        </Button>
                    </Col>
                    <Col xs={6}>
                        <Button
                            block
                            bsStyle="primary"
                            type="submit"
                            form="restaurant-details-form"
                            disabled={
                                this.state.isDisabled ||
                                !this.validateCoordinates()
                            }
                        >
                            {translator.translate("_save_")}
                        </Button>
                    </Col>
                </Row>
            </Modal.Footer>
        );
    }

    enableButton() {
        this.setState({ isDisabled: false });
    }

    disableButton() {
        this.setState({ isDisabled: true });
    }

    renderBranchList(editable) {
        const isSendToHaysell = this.restaurantDetails.isSendToHaysell;
        return (
            <BranchList
                canEdit={editable}
                expanded={editable}
                isSendToHaysell={isSendToHaysell}
                branches={this.restaurantDetails.branches}
                handleBranchEdit={this.handleBranchEdit.bind(this)}
                changeBranchName={(e, key, i) => {
                    const branches = this.restaurantDetails.branches;
                    branches[i].restaurantInformation.name = e.target.value;
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                addressHandler={(e, key, i) => {
                    const branches = this.restaurantDetails.branches;
                    branches[i].restaurantInformation.location[key] =
                        e.target.value;
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                nameHandler={(e, key, i) => {
                    const branches = this.restaurantDetails.branches;
                    branches[i].name = e.target.value;
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                nameHandlerEn={(e, key, i) => {
                    const branches = this.restaurantDetails.branches;
                    branches[i].nameEn = e.target.value;
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                nameHandlerRu={(e, key, i) => {
                    const branches = this.restaurantDetails.branches;
                    branches[i].nameRu = e.target.value;
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                hintHandler={(e, i) => {
                    const branches = this.restaurantDetails.branches;
                    branches[i].restaurantInformation.hint = e.target.value;
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                hintHandlerEn={(e, i) => {
                    const branches = this.restaurantDetails.branches;
                    branches[i].restaurantInformation.hintEn = e.target.value;
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                hintHandlerRu={(e, i) => {
                    const branches = this.restaurantDetails.branches;
                    branches[i].restaurantInformation.hintRu = e.target.value;
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                phoneNumbersHandler={(e, i, index) => {
                    const branches = this.restaurantDetails.branches;
                    branches[i].restaurantInformation.phoneNumbers[index] =
                        e.target.value;
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                coordinatesLatHandler={(e, i) => {
                    const branches = this.restaurantDetails.branches;
                    branches[i].restaurantInformation.location.coordinates.lat =
                        e.target.value;
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                coordinatesLngHandler={(e, i) => {
                    const branches = this.restaurantDetails.branches;
                    branches[i].restaurantInformation.location.coordinates.lng =
                        e.target.value;
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                workingHoursStartHandler={(e, i) => {
                    const branches = this.restaurantDetails.branches;
                    branches[i].restaurantInformation.workingHours.start = e;
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                workingHoursEndHandler={(e, i) => {
                    const branches = this.restaurantDetails.branches;
                    branches[i].restaurantInformation.workingHours.end = e;
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                holidaysFromHandler={(e, i, index) => {
                    const branches = this.restaurantDetails.branches;
                    branches[i].restaurantInformation.holidays.from = e;
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                holidaysToHandler={(e, i, index) => {
                    const branches = this.restaurantDetails.branches;
                    branches[i].restaurantInformation.holidays.to = e;
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                nonWorkingDaysHandler={(e, i, index) => {
                    const branches = this.restaurantDetails.branches;
                    branches[i].restaurantInformation.nonWorkingDays[index] =
                        e.target.checked;
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                isFromBackEntranceHandler={(e, i, index) => {
                    const branches = this.restaurantDetails.branches;
                    branches[i].restaurantInformation.isFromBackEntrance =
                        e.target.checked;
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                isPickupCooperationHandler={(e, i) => {
                    const branches = this.restaurantDetails.branches;
                    branches[i].restaurantInformation.isPickupCooperation =
                        e.target.checked;
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                isProductManagementHandler={(e, i) => {
                    const branches = this.restaurantDetails.branches;
                    branches[i].restaurantInformation.productManagement =
                        e.target.checked;
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                distanceCalcExcludedPartnerHandler={(e, i, index) => {
                    const branches = this.restaurantDetails.branches;
                    branches[
                        i
                        ].restaurantInformation.distanceCalcExcludedPartner =
                        e.target.checked;
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                haysellRegionHandler={(e, i, index) => {
                    const branches = this.restaurantDetails.branches;
                    if (branches[i].restaurantInformation.haysell) {
                        branches[i].restaurantInformation.haysell.region =
                            e.target.value;
                    } else {
                        branches[i].restaurantInformation.haysell = {
                            region: e.target.value,
                        };
                    }
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                differences={this.restaurantDetails.differences}
            />
        );
    }

    renderBranchDetailsModal() {
        const isSendToHaysell = this.restaurantDetails.isSendToHaysell;

        return (
            <BranchDetails
                onClose={this.resetBranchDetails.bind(this)}
                onSave={this.closeBranchDetailsModal.bind(this)}
                branch={this.state.branch}
                branchIndex={this.state.branchIndex}
                isSendToHaysell={isSendToHaysell}
                branches={this.restaurantDetails.branches}
                changeBranchName={(e, key, i) => {
                    const branches = this.restaurantDetails.branches;
                    branches[i].restaurantInformation.name = e.target.value;
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                removeBranch={(branchId) => {
                    this.restaurantDetails.branches =
                        this.restaurantDetails.branches.map((branch) => {
                            return branch._id === branchId
                                ? {
                                    ...branch,
                                    deleted: true,
                                }
                                : branch;
                        });
                    this.closeBranchDetailsModal();
                    this.forceUpdate();
                    //delete from local
                }}
                addressHandler={(e, key, i) => {
                    const branches = this.restaurantDetails.branches;
                    branches[i].restaurantInformation.location[key] =
                        e.target.value;
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                nameHandler={(e, key, i) => {
                    const branches = this.restaurantDetails.branches;
                    branches[i].name = e.target.value;
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                nameHandlerEn={(e, key, i) => {
                    const branches = this.restaurantDetails.branches;
                    branches[i].nameEn = e.target.value;
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                nameHandlerRu={(e, key, i) => {
                    const branches = this.restaurantDetails.branches;
                    branches[i].nameRu = e.target.value;
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                branchKeyHandler={(e, key, i) => {
                    const branches = this.restaurantDetails.branches;
                    branches[i].restaurantInformation.branchKey =
                        e.target.value;
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                hintHandler={(e, i) => {
                    const branches = this.restaurantDetails.branches;
                    branches[i].restaurantInformation.hint = e.target.value;
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                hintHandlerEn={(e, i) => {
                    const branches = this.restaurantDetails.branches;
                    branches[i].restaurantInformation.hintEn = e.target.value;
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                hintHandlerRu={(e, i) => {
                    const branches = this.restaurantDetails.branches;
                    branches[i].restaurantInformation.hintRu = e.target.value;
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                phoneNumbersHandler={(e, i, index) => {
                    const branches = this.restaurantDetails.branches;
                    branches[i].restaurantInformation.phoneNumbers[index] =
                        e.target.value;
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                coordinatesLatHandler={(e, i) => {
                    const branches = this.restaurantDetails.branches;
                    branches[i].restaurantInformation.location.coordinates.lat =
                        e.target.value;
                    this.restaurantDetails.branches = branches;
                }}
                coordinatesLngHandler={(e, i) => {
                    const branches = this.restaurantDetails.branches;
                    branches[i].restaurantInformation.location.coordinates.lng =
                        e.target.value;
                    this.restaurantDetails.branches = branches;
                }}
                workingHoursStartHandler={(e, i) => {
                    const branches = this.restaurantDetails.branches;
                    branches[i].restaurantInformation.workingHours.start = e;
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                workingHoursEndHandler={(e, i) => {
                    const branches = this.restaurantDetails.branches;
                    branches[i].restaurantInformation.workingHours.end = e;
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                holidaysFromHandler={(e, i, index) => {
                    const branches = this.restaurantDetails.branches;
                    branches[i].restaurantInformation.holidays.from = e;
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                holidaysToHandler={(e, i, index) => {
                    const branches = this.restaurantDetails.branches;
                    branches[i].restaurantInformation.holidays.to = e;
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                nonWorkingDaysHandler={(e, i, index) => {
                    const branches = this.restaurantDetails.branches;
                    branches[i].restaurantInformation.nonWorkingDays[index] =
                        e.target.checked;
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                isFromBackEntranceHandler={(e, i, index) => {
                    const branches = this.restaurantDetails.branches;
                    branches[i].restaurantInformation.isFromBackEntrance =
                        e.target.checked;
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                isPickupCooperationHandler={(e, i) => {
                    const branches = this.restaurantDetails.branches;
                    branches[i].restaurantInformation.isPickupCooperation =
                        e.target.checked;
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                isProductManagementHandler={(e, i) => {
                    const branches = this.restaurantDetails.branches;
                    branches[i].restaurantInformation.productManagement =
                        e.target.checked;
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                distanceCalcExcludedPartnerHandler={(e, i, index) => {
                    const branches = this.restaurantDetails.branches;
                    branches[
                        i
                        ].restaurantInformation.distanceCalcExcludedPartner =
                        e.target.checked;
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                haysellRegionHandler={(e, i, index) => {
                    const branches = this.restaurantDetails.branches;
                    if (branches[i].restaurantInformation.haysell) {
                        branches[i].restaurantInformation.haysell.region =
                            e.target.value;
                    } else {
                        branches[i].restaurantInformation.haysell = {
                            region: e.target.value,
                        };
                    }
                    this.restaurantDetails.branches = branches;
                    this.forceUpdate();
                }}
                differences={this.restaurantDetails.differences}
            />
        );
    }

    getBranchData(name) {
        return {
            // _id: shortId.generate(),
            name: name,
            restaurantInformation: {
                holidays: {
                    to: "",
                    from: "",
                },
                workingHours: {
                    end: "",
                    start: "",
                },
                location: {
                    coordinates: {
                        lng: "",
                        lat: "",
                    },
                    address: "",
                    addressEn: "",
                    addressRu: "",
                },
                nonWorkingDays: [],
                phoneNumbers: [""],
                isFromBackEntrance: false,
                distanceCalcExcludedPartner: false,
            },
        };
    }

    renderBranches() {
        return (
            <CollapseList
                isList={false}
                expanded={true}
                key={"branches"}
                headerTitle={translator.translate("_branches_")}
                child={this.renderBranchList(true)}
                childClassName={`shop-list`}
                restaurantDetails={this.props.restaurantDetails}
                editable={true}
                addBranch={(name) => {
                    let newBranchData = this.getBranchData(name);
                    newBranchData.isExpanded = true;
                    this.restaurantDetails.branches.unshift(newBranchData);
                    this.forceUpdate();
                    this.handleBranchEdit(newBranchData, 0);
                }}
            />
        );
    }

    renderName() {
        const restaurant = this.restaurantDetails,
            name = restaurant ? restaurant.name : "";
        return this.renderFormInput(
            "_restaurant_name_",
            "name",
            name,
            restaurantConf.validations.name,
            (e) => {
                this.restaurantDetails.name = e.target.value;
                this.forceUpdate();
            },
        );
    }

    renderDeliveryRegion(label, name, value, validations, changeHandler) {
        const disabledValidations = {
            ...validations,
            disabled: true,
        };

        return this.renderFormInput(
            label,
            name,
            value,
            disabledValidations,
            changeHandler,
        );
    }

    renderDeliveryRegions(label) {
        const { regions } = this.props;
        const currentRegionIds = this.restaurantDetails.restaurantInformation?.availableRegions || [];

        const options = regions.map((region) => ({
            label: region.name,
            value: region.id || region._id,
        }));

        const selectedOptions = options.filter((opt) =>
            currentRegionIds.includes(opt.value),
        );

        return (
            <div className="display-flex align-center">
                <label className={`label-width`}>
                    {translator.translate(label)}:
                </label>
                <Select
                    className="my-custom-input"
                    isMulti
                    options={options}
                    value={selectedOptions}
                    onChange={(selected) => {
                        const selectedIds = selected
                            ? selected.map((s) => s.value)
                            : [];
                        this.restaurantDetails.restaurantInformation.availableRegions = selectedIds;
                        this.forceUpdate();
                    }}
                    placeholder={translator.translate(label)}
                />
            </div>
        );
    }

    renderRestaurantRegion(label, name, value, validations) {
        return this.renderRestaurantAddress(
            label,
            name,
            value,
            validations,
            () => {
            },
        );
    }

    renderNameEn() {
        const restaurant = this.restaurantDetails,
            nameEn = restaurant ? restaurant.nameEn : "";
        return this.renderFormInput(
            "_restaurant_name_en",
            "nameEn",
            nameEn,
            restaurantConf.validations.name,
            (e) => {
                this.restaurantDetails.nameEn = e.target.value;
                this.forceUpdate();
            },
        );
    }

    renderNameRu() {
        const restaurant = this.restaurantDetails,
            nameRu = restaurant ? restaurant.nameRu : "";
        return this.renderFormInput(
            "_restaurant_name_ru",
            "nameRu",
            nameRu,
            restaurantConf.validations.name,
            (e) => {
                this.restaurantDetails.nameRu = e.target.value;
                this.forceUpdate();
            },
        );
    }

    renderId() {
        const restaurant = this.restaurantDetails,
            restaurantId = restaurant ? restaurant.restaurantId : "";
        return this.renderFormInput(
            "_restaurant_id_",
            "restaurantId",
            restaurantId,
            restaurantConf.validations.restaurantId,
            (e) => {
                this.restaurantDetails.restaurantId = e.target.value;
                this.forceUpdate();
            },
        );
    }

    renderNId() {
        const restaurant = this.restaurantDetails,
            nRestaurantId = restaurant ? restaurant.nRestaurantId : "";
        return this.renderFormInput(
            "_restaurant_new_id_",
            "nRestaurantId",
            nRestaurantId,
            restaurantConf.validations.nRestaurantId,
            (e) => {
                this.restaurantDetails.nRestaurantId = e.target.value;
                this.forceUpdate();
            },
        );
    }

    renderBranchId() {
        const restaurant = this.restaurantDetails.restaurantInformation,
            branchKey = restaurant ? restaurant.branchKey : "";
        return this.renderFormInput(
            "_branch_key_",
            "branchKey",
            branchKey,
            restaurantConf.validations.branchKey,
            (e) => {
                this.restaurantDetails.restaurantInformation.branchKey = e.target.value;
                this.forceUpdate();
            },
        );
    }

    renderLegalPersonName() {
        const legalPersonName = this.restaurantDetails.legalPersonName;
        return this.renderFormInput(
            "_legal_person_name_",
            "legalPersonName",
            legalPersonName,
            restaurantConf.validations.legalPersonName,
            (e) => {
                this.restaurantDetails.legalPersonName = e.target.value;
                this.forceUpdate();
            },
        );
    }

    renderLegalAddress() {
        const partnerLegalAddress = this.restaurantDetails.partnerLegalAddress;
        return this.renderFormInput(
            "_legal_person_address_",
            "partnerLegalAddress",
            partnerLegalAddress,
            restaurantConf.validations.partnerLegalAddress,
            (e) => {
                this.restaurantDetails.partnerLegalAddress = e.target.value;
                this.forceUpdate();
            },
        );
    }

    renderDirectorFullName() {
        const directorFullName = this.restaurantDetails.directorFullName;
        return this.renderFormInput(
            "_director_full_name_",
            "directorFullName",
            directorFullName,
            restaurantConf.validations.directorFullName,
            (e) => {
                this.restaurantDetails.directorFullName = e.target.value;
                this.forceUpdate();
            },
        );
    }

    renderCompany(label, name, value, validations, changeHandler) {
        if (!value) {
            this.state.isDisabled = true;
        } else {
            this.state.isDisabled = false;
        }
        return (
            <React.Fragment>
                <div className="display-flex align-center">
                    {label ? (
                        <label
                            htmlFor={this.props.htmlFor}
                            className={"label-width"}
                        >
                            {translator.translate(label)}
                        </label>
                    ) : null}
                    <Select
                        className={label ? "my-custom-input" : ""}
                        onChange={changeHandler}
                        options={COMPANY.companies("label")}
                        required={"required"}
                        validations={validations}
                        placeholder={translator.translate(label)}
                        value={
                            value
                                ? {
                                    label: COMPANY[value].name,
                                    value: value,
                                }
                                : null
                        }
                    />
                </div>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <div style={{ color: "red", width: "70%" }}>
                        {this.state.isDisabled
                            ? translator.translate("_required_field_")
                            : ""}
                    </div>
                </div>
            </React.Fragment>
        );
    }

    renderTaxpayerIdentificationNumber() {
        const taxpayerIdentificationNumber =
            this.restaurantDetails.taxpayerIdentificationNumber;
        return this.renderFormInput(
            "_taxpayer_identification_number_",
            "taxpayerIdentificationNumber",
            taxpayerIdentificationNumber,
            restaurantConf.validations.taxpayerIdentificationNumber,
            (e) => {
                this.restaurantDetails.taxpayerIdentificationNumber =
                    e.target.value;
                this.forceUpdate();
            },
        );
    }

    renderBankName() {
        const bankName = this.restaurantDetails.bankName;
        return this.renderFormInput(
            "_bank_name",
            "bankName",
            bankName,
            restaurantConf.validations.bankName,
            (e) => {
                this.restaurantDetails.bankName = e.target.value;
                this.forceUpdate();
            },
        );
    }

    renderAccountNumber() {
        const accountNumber = this.restaurantDetails.accountNumber;
        return this.renderFormInput(
            "_account_number_",
            "accountNumber",
            accountNumber,
            restaurantConf.validations.accountNumber,
            (e) => {
                this.restaurantDetails.accountNumber = e.target.value;
                this.forceUpdate();
            },
        );
    }

    renderPassportRequires() {
        return (
            <div className="display-flex">
                <label className={`label-width`}>
                    {translator.translate("_passport_requires_")}:
                </label>
                <div className="my-custom-input margin-to-left">
                    <Checkbox
                        className="margin-bottom order-margin"
                        checked={this.restaurantDetails.passportRequired}
                        onChange={(e) => {
                            this.restaurantDetails.passportRequired =
                                e.target.checked;
                            this.forceUpdate();
                        }}
                    />
                </div>
            </div>
        );
    }

    renderPriceInNotification() {
        return (
            <div className="display-flex">
                <label className={`label-width`}>
                    {translator.translate("_price_in_notification_")}:
                </label>
                <div className="my-custom-input margin-to-left">
                    <Checkbox
                        className="margin-bottom order-margin"
                        checked={this.restaurantDetails.specialHintType === 2}
                        onChange={(e) => {
                            this.restaurantDetails.specialHintType = e.target.checked ? 2 : 1;
                            this.forceUpdate();
                        }}
                    />
                </div>
            </div>
        );
    }

    renderAahSaler() {
        return (
            <div className="display-flex">
                <label className={`label-width`}>
                    {translator.translate("_aah_saler")}:
                </label>
                <div className="my-custom-input margin-to-left">
                    <Checkbox
                        className="margin-bottom order-margin"
                        checked={this.restaurantDetails.aahSaler}
                        onChange={(e) => {
                            this.restaurantDetails.aahSaler = e.target.checked;
                            this.forceUpdate();
                        }}
                    />
                </div>
            </div>
        );
    }

    renderEmail() {
        const email = this.restaurantDetails.email;
        return this.renderFormInput(
            "_email_",
            "email",
            email,
            restaurantConf.validations.email,
            (e) => {
                this.restaurantDetails.email = e.target.value;
                this.forceUpdate();
            },
        );
    }

    renderPaymentPeriod() {
        const paymentPeriod =
                this.restaurantDetails.cooperationType.paymentPeriod,
            cooperationType = this.restaurantDetails.cooperationType,
            paymentType = cooperationType ? cooperationType.paymentType : null,
            payerType = cooperationType ? cooperationType.payerType : null;
        // if (
        //     RESTAURANT_COOPERATION_TYPES.CASH.id === paymentType &&
        //     RESTAURANT_PAYERS.DISTRIBUTOR.id === payerType
        // ) {
        //     this.restaurantDetails.cooperationType.paymentPeriod = "";
        //     return null;
        // }
        return this.renderFormInput(
            "_payment_period_",
            "paymentPeriod",
            paymentPeriod,
            restaurantConf.validations.paymentPeriod,
            (e) => {
                this.restaurantDetails.cooperationType.paymentPeriod =
                    e.target.value;
                this.forceUpdate();
            },
            "payment-period-width",
        );
    }

    renderRadioGroup(data, i, key, clickHandler, obj) {
        obj = obj || this.restaurantDetails.cooperationType;

        let checked;

        if (key === "invoiceIssuanceType") {
            checked =
                obj &&
                data.value === obj[key];
        } else {
            const defaultSelectedRadio = 0;
            checked =
                (obj && data.value === obj[key]) ||
                defaultSelectedRadio === i;
        }

        return (
            <RadioGroup
                id={key}
                key={i}
                title={translator.translate(data.name)}
                value={data.value}
                checked={checked}
                onClick={clickHandler}
                name={key}
                disabled={data.disabled}
                customClass="margin-to-right"
                customRadioClass="to-right"
            />
        );
    }

    renderCooperationMethod() {
        const cooperationType = this.restaurantDetails.cooperationType;
        // 	paymentType = cooperationType ? cooperationType.paymentType : null;
        // if (RESTAURANT_COOPERATION_TYPES.CASH.id !== paymentType) {
        // 	return null;
        // }
        return (
            <div className="display-flex">
                <label className={`label-width`}>
                    {translator.translate("_cooperation_method_")}:
                </label>
                <div className="my-custom-input margin-to-left">
                    {RESTAURANT_COOPERATION_METHODS.cooperationMethods().map(
                        (data, i) => {
                            return this.renderRadioGroup(
                                data,
                                i,
                                "method",
                                (e) => {
                                    this.restaurantDetails.cooperationType.method =
                                        Number(e.target.value);
                                    this.forceUpdate();
                                },
                            );
                        },
                    )}
                </div>
            </div>
        );
    }

    renderCooperationType() {
        return (
            <div className="display-flex">
                <label className={`label-width`}>
                    {translator.translate("_cooperation_type_")}:
                </label>
                <div className="my-custom-input margin-to-left">
                    {RESTAURANT_COOPERATION_TYPES.cooperationMethods().map(
                        (data, i) => {
                            return this.renderRadioGroup(
                                data,
                                i,
                                "paymentType",
                                (e) => {
                                    this.restaurantDetails.cooperationType.paymentType =
                                        Number(e.target.value);
                                    this.restaurantDetails.cooperationType.payerType = 1;
                                    // if (
                                    //     RESTAURANT_COOPERATION_TYPES.CASH.id !==
                                    //     this.restaurantDetails.cooperationType
                                    //         .paymentType
                                    // ) {
                                    //     //this.restaurantDetails.cooperationType.method = 1;
                                    //     this.restaurantDetails.cooperationType.payerType = 1;
                                    // } else {
                                    //     this.restaurantDetails.cooperationType.payerType = 0;
                                    //     //this.restaurantDetails.cooperationType.method = 0;
                                    // }
                                    this.forceUpdate();
                                },
                            );
                        },
                    )}
                </div>
            </div>
        );
    }

    renderInvoiceType() {
        return (
            <div className="display-flex">
                <label className={`label-width`}>
                    {translator.translate("_provide_cash_register_receipt_")}:
                </label>
                <div className="my-custom-input margin-to-left">
                    <Checkbox
                        className="margin-bottom order-margin"
                        checked={
                            this.restaurantDetails.cooperationType
                                .provideCashRegisterReceipt
                        }
                        onChange={(e) => {
                            const checked = e.target.checked;
                            this.restaurantDetails.cooperationType.provideCashRegisterReceipt = checked;
                            if (checked) {
                                this.restaurantDetails.cooperationType.printHdmForSupplier = false;
                            }
                            this.forceUpdate();
                        }}
                    />
                </div>
            </div>
        );
    }

    renderPrintHdm() {
        return (
            <div className="display-flex">
                <label className={`label-width`}>
                    {translator.translate("_print_hdm_for_supplier_")}:
                </label>
                <div className="my-custom-input margin-to-left">
                    <Checkbox
                        className="margin-bottom order-margin"
                        checked={
                            this.restaurantDetails.cooperationType.printHdmForSupplier
                        }
                        onChange={(e) => {
                            const checked = e.target.checked;
                            this.restaurantDetails.cooperationType.printHdmForSupplier = checked;
                            if (checked) {
                                this.restaurantDetails.cooperationType.provideCashRegisterReceipt = false;
                            }
                            this.forceUpdate();
                        }}
                    />
                </div>
            </div>
        );
    }

    renderInvoiceIssuingType() {
        return (
            <div className="display-flex">
                <label className={`label-width`}>
                    {translator.translate("_invoice_issuing_type_on_behalf_of_the_partner_")}:
                </label>
                <div className="my-custom-input margin-to-left">
                    {INCOME_SOURCE.source().map((data, i) => {
                        return this.renderRadioGroup(
                            data,
                            i,
                            "invoiceIssuanceType",
                            (e) => {
                                this.restaurantDetails.invoiceIssuanceType = Number(
                                    e.target.value,
                                );
                                this.forceUpdate();
                            },
                            this.restaurantDetails,
                        );
                    })}
                </div>
            </div>
        );
    }

    renderIsSupplerWeb() {
        return (
            <div className="display-flex">
                <label className={`label-width`}>
                    {translator.translate("_is_used_supplier_web_")}:
                </label>
                <div className="my-custom-input margin-to-left">
                    <Checkbox
                        className="margin-bottom order-margin"
                        checked={
                            this.restaurantDetails.cooperationType.isSupplierWeb
                        }
                        onChange={(e) => {
                            this.restaurantDetails.cooperationType.isSupplierWeb =
                                e.target.checked;
                            this.forceUpdate();
                        }}
                    />
                </div>
            </div>
        );
    }

    renderIsPrintHdm() {
        return (
            <div className="display-flex">
                <label className={`label-width`}>
                    {translator.translate(
                        "_do_not_print_hdm_for_bank_transactions_",
                    )}
                    :
                </label>
                <div className="my-custom-input margin-to-left">
                    <Checkbox
                        className="margin-bottom order-margin"
                        checked={
                            this.restaurantDetails.cooperationType
                                .doNotPrintHdmInBankTransaction
                        }
                        onChange={(e) => {
                            this.restaurantDetails.cooperationType.doNotPrintHdmInBankTransaction =
                                e.target.checked;
                            this.forceUpdate();
                        }}
                    />
                </div>
            </div>
        );
    }

    renderHintsForB2BService() {
        return (
            <div className="display-flex">
                <label className={`label-width`}>
                    {translator.translate("_hints_for_b2b_service_")}:
                </label>
                <div className="display-flex">
                    <div className="display-flex margin-to-left">
                        <Checkbox
                            className="margin-bottom order-margin"
                            disabled={
                                this.restaurantDetails.b2bHintType ===
                                B2B_SERVICE_HINTS.InvoiceBUYAM
                            }
                            checked={
                                this.restaurantDetails.b2bHintType ===
                                B2B_SERVICE_HINTS.PrintReceiptWithTIN
                            }
                            onChange={(e) => {
                                this.restaurantDetails.b2bHintType = e.target
                                    .checked
                                    ? B2B_SERVICE_HINTS.PrintReceiptWithTIN
                                    : B2B_SERVICE_HINTS.NONE;
                                this.forceUpdate();
                            }}
                        />
                        <label>
                            {translator.translate("_print_receipt_with_tin_")}
                        </label>
                    </div>
                    <div
                        className="display-flex"
                        style={{ marginLeft: "30px" }}
                    >
                        <Checkbox
                            className="margin-bottom order-margin"
                            disabled={
                                this.restaurantDetails.b2bHintType ===
                                B2B_SERVICE_HINTS.PrintReceiptWithTIN
                            }
                            checked={
                                this.restaurantDetails.b2bHintType ===
                                B2B_SERVICE_HINTS.InvoiceBUYAM
                            }
                            onChange={(e) => {
                                this.restaurantDetails.b2bHintType = e.target
                                    .checked
                                    ? B2B_SERVICE_HINTS.InvoiceBUYAM
                                    : B2B_SERVICE_HINTS.NONE;
                                this.forceUpdate();
                            }}
                        />
                        <label>
                            {translator.translate("_invoice_buy_am_")}
                        </label>
                    </div>
                </div>
            </div>
        );
    }

    renderContactsNotifications() {
        const notificationEmails = this.restaurantDetails?.notificationEmails;
        const telegramChannelId = this.restaurantDetails?.telegramChannelId;
        const notificationValidations = restaurantConf.validations.notificationEmails;
        const telegramValidations = restaurantConf.validations.telegramChannelId;

        return (
            <div className="display-flex">
                <label className="label-width">
                    {translator.translate("_contacts_for_notifications_")}:
                </label>
                <div className="my-custom-input margin-to-left" style={{ width: "-webkit-fill-available" }}>
                    <div className="display-flex">
                        {/* Email Input Container */}
                        <div style={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            marginRight: "20px",
                        }}>
                            <div className="form-input-wrapper">
                                <label className="form-input-label-top" htmlFor="notificationEmails">
                                    {translator.translate("_emails_")}
                                </label>
                                <FormInput
                                    id="notificationEmails"
                                    name="notificationEmails"
                                    value={notificationEmails || ""}
                                    onChange={(e) => {
                                        this.restaurantDetails.notificationEmails = e.target.value;
                                        this.forceUpdate();
                                    }}
                                    placeholder={"_email_"}
                                    validations={notificationValidations.validations}
                                    validationErrors={notificationValidations.validationErrors}
                                    required={notificationValidations.required}
                                    validationError={
                                        notificationValidations.required
                                            ? translator.translate("_required_field_")
                                            : ""
                                    }
                                    disabled={notificationValidations.disabled}
                                />
                            </div>
                            <div className="default-font distance-field">
                                {translator.translate("_notification_emails_help_")}
                            </div>
                        </div>

                        {/* Telegram Input Container */}
                        <div style={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                        }}>
                            <div className="form-input-wrapper">
                                <label className="form-input-label-top" htmlFor="telegramChannelId">
                                    {translator.translate("_telegram_channel_id_")}
                                </label>
                                <FormInput
                                    id="telegramChannelId"
                                    name="telegramChannelId"
                                    value={telegramChannelId || ""}
                                    onChange={(e) => {
                                        this.restaurantDetails.telegramChannelId = e.target.value;
                                        this.forceUpdate();
                                    }}
                                    placeholder="Telegram Channel ID"
                                    validations={telegramValidations.validations}
                                    validationErrors={telegramValidations.validationErrors}
                                    required={telegramValidations.required}
                                    validationError={
                                        telegramValidations.required
                                            ? translator.translate("_required_field_")
                                            : ""
                                    }
                                    disabled={telegramValidations.disabled}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderPayer() {
        const cooperationType = this.restaurantDetails.cooperationType,
            paymentType = cooperationType ? cooperationType.paymentType : null;
        let disabled = false;
        // if (RESTAURANT_COOPERATION_TYPES.CASH.id !== paymentType) {
        //     // disabled = true
        //     return null;
        // }
        return (
            <div className="display-flex">
                <label className={`label-width`}>
                    {translator.translate("_payer_")}:
                </label>
                <div className="my-custom-input margin-to-left">
                    {RESTAURANT_PAYERS.restaurantPayers().map((data, i) => {
                        return this.renderRadioGroup(
                            { ...data, disabled },
                            i,
                            "payerType",
                            (e) => {
                                this.restaurantDetails.cooperationType.payerType =
                                    Number(e.target.value);
                                this.forceUpdate();
                            },
                        );
                    })}
                </div>
            </div>
        );
    }

    renderSourceOfIncome() {
        return (
            <div className="display-flex">
                <label className={`label-width`}>
                    {translator.translate("_source_of_income_")}:
                </label>
                <div className="my-custom-input margin-to-left">
                    {RESTAURANT_SOURCE_OF_INCOME.source().map((data, i) => {
                        return this.renderRadioGroup(
                            data,
                            i,
                            "sourceOfIncome",
                            (e) => {
                                this.restaurantDetails.cooperationType.sourceOfIncome =
                                    Number(e.target.value);
                                this.forceUpdate();
                            },
                        );
                    })}
                </div>
            </div>
        );
    }

    renderMeasurement(measurement, onChange) {
        const measurements = PERCENTAGE_MEASUREMENTS.measurments();
        return (
            <FormControl
                componentClass="select"
                onChange={onChange}
                defaultValue={measurement}
                className={"label-distance"}
            >
                {measurements.map((data, key) => {
                    return (
                        <option key={key} value={data.value}>
                            {translator.translate(data.name)}
                        </option>
                    );
                })}
            </FormControl>
        );
    }

    renderPercentage() {
        if (
            this.restaurantDetails.cooperationType.sourceOfIncome !==
            RESTAURANT_SOURCE_OF_INCOME.COMMISSION.id
        ) {
            return null;
        }
        const ourOrder = this.restaurantDetails.customerPercentage,
            themselvesOrder = this.restaurantDetails.restaurantPercentage,
            percentageValidation = {
                validations: {
                    matchRegexp: /^\d+(\.\d{1,})?$/,
                },
                validationErrors: {
                    matchRegexp: "_percentage_error_",
                },
            };
        return (
            <div className="display-flex align-center">
                <label className={"label-width"}>
                    {translator.translate("_percentage_")}:
                </label>
                <div className="display-flex my-custom-input margin-to-left">
                    <div className="display-flex margin-right">
                        {this.renderFormInput(
                            "_our_order_",
                            "ourOrder",
                            ourOrder.value,
                            percentageValidation,
                            (e) => {
                                this.restaurantDetails.customerPercentage.value =
                                    e.target.value;
                                this.forceUpdate();
                            },
                        )}
                        <div className="display-flex">
                            {this.renderMeasurement(
                                ourOrder.measurement,
                                (e) => {
                                    this.restaurantDetails.customerPercentage.measurement =
                                        e.target.value;
                                    this.forceUpdate();
                                },
                            )}
                        </div>
                    </div>
                    <div className="display-flex">
                        {this.renderFormInput(
                            "_themselves_order_",
                            "themselvesOrder",
                            themselvesOrder.value,
                            percentageValidation,
                            (e) => {
                                this.restaurantDetails.restaurantPercentage.value =
                                    e.target.value;
                                this.forceUpdate();
                            },
                        )}
                        <div className="display-flex">
                            {this.renderMeasurement(
                                themselvesOrder.measurement,
                                (e) => {
                                    this.restaurantDetails.restaurantPercentage.measurement =
                                        e.target.value;
                                    this.forceUpdate();
                                },
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderApplicableDeliveryTime() {
        const restaurant = this.restaurantDetails,
            applicableDeliveryTime = restaurant
                ? restaurant.applicableDeliveryTime
                : "";
        return this.renderFormInput(
            "_applicable_delivery_time_",
            "applicableDeliveryTime",
            applicableDeliveryTime,
            restaurantConf.validations.applicableDeliveryTime,
            (e) => {
                this.restaurantDetails.applicableDeliveryTime = e.target.value;
                this.forceUpdate();
            },
        );
    }

    renderRegionFields() {
        return (
            <div className="display-flex">
                <label className="label-button">
                    <Button
                        block
                        onClick={() => this.getDistrict()}
                        bsStyle="primary"
                        className="new-button-to-top"
                        style={{ display: "flex", alignItems: "center", gap: 5 }}
                    >
                        <span className={"glyphicon glyphicon-plus-sign"} />
                        {translator.translate("_region_fields_")}
                    </Button>
                </label>
            </div>
        );
    }

    renderType() {
        return (
            <div className="display-flex">
                <label className={`label-width`}>
                    {translator.translate("_partner_type_")}:
                </label>
                <div className="my-custom-input margin-to-left">
                    {RESTAURANT_TYPES.types().map((data, i) => {
                        return this.renderRadioGroup(
                            data,
                            i,
                            "type",
                            (e) => {
                                this.restaurantDetails.type = Number(
                                    e.target.value,
                                );
                                this.forceUpdate();
                            },
                            this.restaurantDetails,
                        );
                    })}
                </div>
            </div>
        );
    }

    renderSendToSupplier() {
        return (
            <div className="display-flex">
                <label className={`label-width`}>
                    {translator.translate("_auto_send_to_supplier_")}:
                </label>
                <div className="my-custom-input margin-to-left">
                    <Checkbox
                        className="margin-bottom order-margin"
                        checked={this.restaurantDetails.autoSendToPartner}
                        onChange={(e) => {
                            this.restaurantDetails.autoSendToPartner =
                                e.target.checked;
                            this.forceUpdate();
                        }}
                    />
                </div>
            </div>
        );
    }

    renderSendToHaysell(checked, changeHandler) {
        return (
            <div className="display-flex">
                <label className={`label-width`}>
                    {translator.translate("_send_to_haysell")}:
                </label>
                <div className="my-custom-input margin-to-left">
                    <Checkbox
                        className="margin-bottom order-margin"
                        checked={checked}
                        onChange={(e) => {
                            changeHandler(e);
                            this.forceUpdate();
                        }}
                    />
                </div>
            </div>
        );
    }

    renderHaysellUrl() {
        const haysell = this.restaurantDetails.restaurantInformation
                ? this.restaurantDetails.restaurantInformation.haysell
                : null,
            haysellUrl = haysell ? haysell.url : "";
        return this.renderFormInput(
            "_haysell_URL_",
            "haysellUrl",
            haysellUrl,
            {},
            (e) => {
                if (this.restaurantDetails.restaurantInformation.haysell) {
                    this.restaurantDetails.restaurantInformation.haysell.url =
                        e.target.value;
                } else {
                    this.restaurantDetails.restaurantInformation.haysell = {
                        url: e.target.value,
                    };
                }
                this.forceUpdate();
            },
        );
    }

    renderHaysellToken() {
        const haysell = this.restaurantDetails.restaurantInformation
                ? this.restaurantDetails.restaurantInformation.haysell
                : null,
            haysellToken = haysell ? haysell.token : "";
        return this.renderFormInput(
            "_haysell_TOKEN_",
            "haysellToken",
            haysellToken,
            {},
            (e) => {
                if (this.restaurantDetails.restaurantInformation.haysell) {
                    this.restaurantDetails.restaurantInformation.haysell.token =
                        e.target.value;
                } else {
                    this.restaurantDetails.restaurantInformation.haysell = {
                        token: e.target.value,
                    };
                }
                this.forceUpdate();
            },
        );
    }

    renderHaysellProfileId() {
        const haysell = this.restaurantDetails.restaurantInformation
                ? this.restaurantDetails.restaurantInformation.haysell
                : null,
            haysellProfileId = haysell ? haysell.profileId : "";
        return this.renderFormInput(
            "_haysel_profile_id",
            "haysellProfileId",
            haysellProfileId,
            {},
            (e) => {
                if (this.restaurantDetails.restaurantInformation.haysell) {
                    this.restaurantDetails.restaurantInformation.haysell.profileId =
                        e.target.value;
                } else {
                    this.restaurantDetails.restaurantInformation.haysell = {
                        profileId: e.target.value,
                    };
                }
                this.forceUpdate();
            },
        );
    }

    renderTransactionMethod() {
        return (
            <div className="display-flex">
                <label className={`label-width`}>
                    {translator.translate("_is_transaction_type_")}:
                </label>
                <div className="my-custom-input margin-to-left">
                    <Checkbox
                        className="margin-bottom order-margin"
                        checked={this.restaurantDetails.isTransactionType}
                        onChange={(e) => {
                            this.restaurantDetails.isTransactionType =
                                e.target.checked;
                            this.forceUpdate();
                        }}
                    />
                </div>
            </div>
        );
    }

    onJksPickClick() {
        if (this.jksInputRef && this.jksInputRef.current) {
            this.jksInputRef.current.click();
        }
    }

    onJksFileChange(e) {
        const file = e && e.target && e.target.files && e.target.files[0] ? e.target.files[0] : null;
        if (!file) {
            this.setState({ jksFile: null });
            return;
        }

        const name = String(file.name || "");
        const ext = name.includes(".") ? name.split(".").pop().toLowerCase() : "";
        const allowed = ["jks", "p12"];
        if (!allowed.includes(ext)) {
            if (this.jksInputRef && this.jksInputRef.current) {
                this.jksInputRef.current.value = "";
            }
            this.setState({ jksFile: null });
            return;
        }

        this.setState({ jksFile: file });
    }

    renderTaxRegimeField() {
        const options = [
            { value: 1, label: "ԱԱՀ-ով հարկվող" },
            { value: 2, label: "ԱԱՀ-ով չհարկվող" },
            { value: 3, label: "Շրջանառության հարկ վճարող" },
            { value: 7, label: "Միկրոձեռնարկատիրություն" },
        ];

        const currentValue = this.restaurantDetails.taxRegime;
        return (
            <div className="display-flex align-center">
                <label className="label-width">{"Հարկման ռեժիմ"}</label>
                <Select
                    className="my-custom-input"
                    onChange={target => {
                        this.restaurantDetails.taxRegime = target ? target.value : null;
                        this.forceUpdate();
                    }}
                    options={options}
                    placeholder={"Հարկման ռեժիմ"}
                    value={options.find(o => o.value === currentValue) || null}
                    isClearable
                />
            </div>
        );
    }

    renderFiscalTextField(label, key) {
        return (
            <div className="display-flex align-center">
                <label className="label-width">{label}</label>
                <div className="my-custom-input">
                    <input
                        type="text"
                        className="form-control"
                        value={this.restaurantDetails[key] || ""}
                        onChange={e => {
                            this.restaurantDetails[key] = e.target.value;
                            this.forceUpdate();
                        }}
                    />
                </div>
            </div>
        );
    }

    renderFiscalNumberField(label, key) {
        return (
            <div className="display-flex align-center">
                <label className="label-width">{label}</label>
                <div className="my-custom-input">
                    <input
                        type="number"
                        className="form-control"
                        value={this.restaurantDetails[key] ?? ""}
                        onChange={e => {
                            const val = e.target.value;
                            this.restaurantDetails[key] = val === "" ? null : val.toString();
                            this.forceUpdate();
                        }}
                    />
                </div>
            </div>
        );
    }

    renderJksSection() {
        const hasExistingJks = Boolean(this.restaurantDetails.hasCertificate);

        console.log('hasExistingJks', hasExistingJks);
        const { jksFile, forceJksReplace } = this.state;
        const showPicker = forceJksReplace || !hasExistingJks || !jksFile;

        return (
            <div style={{ marginTop: 15 }}>
                <div className="display-flex" style={{ gap: 10 }}>
                    <div style={{ display: "flex", alignItems: "center", minWidth: 250, fontWeight: 600, gap: 10 }}>
                        .p12
                        {hasExistingJks && (
                            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                <Glyphicon glyph="ok" style={{ color: "green" }} />
                                <span style={{ color: "green", fontWeight: 600 }}>{"Կցված է"}</span>
                            </div>
                        )}
                    </div>
                    <div style={{ flex: 1, display: "flex", justifyContent: "start", gap: 12 }}>
                        {(showPicker || hasExistingJks) && (
                            <div style={{ display: "block", alignItems: "center", gap: 10 }}>
                                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                    <input
                                        ref={this.jksInputRef}
                                        type="file"
                                        accept=".jks,.p12"
                                        style={{ display: "none" }}
                                        onChange={this.onJksFileChange.bind(this)}
                                    />
                                    <Button bsStyle="default" onClick={this.onJksPickClick.bind(this)}>
                                        {jksFile ? "Փոխարինել ֆայլը" : "Կցել ֆայլ"}
                                    </Button>
                                    {jksFile ? (
                                        <span style={{ fontStyle: "italic" }}>{jksFile.name}</span>
                                    ) : null}
                                </div>

                                <div>
                                    {jksFile && (
                                        <div style={{ marginTop: 10, maxWidth: 320 }}>
                                            <label style={{ display: "block" }}>{"Գաղտնաբառ"}</label>
                                            <input
                                                type="password"
                                                className="form-control"
                                                value={this.state.certPassword}
                                                onChange={(e) => this.setState({ certPassword: e.target.value })}
                                                placeholder=""
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    isSuperAdmin() {
        try {
            const user = security.getUser();
            return user && Number(user.role) === Number(USER_ROLES.SUPER_ADMIN);
        } catch (e) {
            return false;
        }
    }

    renderHdmPicture() {
        const isSuperAdmin = this.isSuperAdmin();
        const current = this.restaurantDetails.cooperationType?.requireReceiptPhoto;
        const isYesChecked = current === true;
        const isNoChecked = current === false;

        const handleYes = () => {
            if (!isSuperAdmin) return;
            if (!this.restaurantDetails.cooperationType) {
                this.restaurantDetails.cooperationType = {};
            }
            const cur = this.restaurantDetails.cooperationType.requireReceiptPhoto;
            this.restaurantDetails.cooperationType.requireReceiptPhoto = cur === true ? null : true;
            this.forceUpdate();
        };

        const handleNo = () => {
            if (!isSuperAdmin) return;
            if (!this.restaurantDetails.cooperationType) {
                this.restaurantDetails.cooperationType = {};
            }
            const cur = this.restaurantDetails.cooperationType.requireReceiptPhoto;
            this.restaurantDetails.cooperationType.requireReceiptPhoto = cur === false ? null : false;
            this.forceUpdate();
        };

        return (
            <div className="display-flex">
                <label className={`label-width`}>
                    {"ՀԴՄ-ի նկար"}:
                </label>
                <div className="my-custom-input margin-to-left" style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                    <span className="display-flex align-center" style={{ gap: "5px" }}>
                        <input
                            type="radio"
                            id="hdm-yes"
                            name="requireReceiptPhoto"
                            checked={isYesChecked}
                            onChange={() => {}}
                            onClick={handleYes}
                            disabled={!isSuperAdmin}
                            className="pointer"
                        />
                        <label htmlFor="hdm-yes" className="pointer" style={{ margin: 0 }}>
                            {translator.translate("_yes_")}
                        </label>
                    </span>
                    <span className="display-flex align-center" style={{ gap: "5px" }}>
                        <input
                            type="radio"
                            id="hdm-no"
                            name="requireReceiptPhoto"
                            checked={isNoChecked}
                            onChange={() => {}}
                            onClick={handleNo}
                            disabled={!isSuperAdmin}
                            className="pointer"
                        />
                        <label htmlFor="hdm-no" className="pointer" style={{ margin: 0 }}>
                            {translator.translate("_no_")}
                        </label>
                    </span>
                </div>
            </div>
        );
    }

    renderNotification() {
        const isSuperAdmin = this.isSuperAdmin();
        if (!isSuperAdmin) return null;
        const checked = !!this.restaurantDetails.notifyPrincipalAccount;
        return (
            <div className="display-flex">
                <label className={`label-width`}>
                    {"Պրինցիպալի Հաշվի Ծանուցում"}:
                </label>
                <div className="my-custom-input margin-to-left">
                    <Checkbox
                        className="margin-bottom order-margin"
                        checked={checked}
                        disabled={!isSuperAdmin}
                        onChange={(e) => {
                            if (!isSuperAdmin) return;
                            this.restaurantDetails.notifyPrincipalAccount = e.target.checked;
                            this.forceUpdate();
                        }}
                    />
                </div>
            </div>
        );
    }

    renderModalBody() {
        // Guard against missing nested data (e.g. new restaurant or incomplete API payload) — fixes "Cannot read properties of undefined (reading 'address')"
        const ri = this.restaurantDetails?.restaurantInformation || {};
        const location = ri.location || {};
        const coords = location.coordinates || {};
        const phoneNumbers = ri.phoneNumbers || [];
        const address = location.address || "";
        const addressEn = location.addressEn || "";
        const addressRu = location.addressRu || "";
        const coordinates = coords && (coords.lat || coords.lng) ? coords : coords;
        const workingHours = ri.workingHours || {};
        const holidays = ri.holidays || { from: "", to: "" };
        const nonWorkingDays = ri.nonWorkingDays || [];
        const isFromBackEntrance = !!ri.isFromBackEntrance;
        const distanceCalcExcludedPartner = !!ri.distanceCalcExcludedPartner;
        const haysellRegion = ri.haysell ? ri.haysell.region || "" : "";
        const company = this.restaurantDetails.company;
        const headOfficeProductManagement = ri.productManagement;
        const isSendToHaysell = this.restaurantDetails.isSendToHaysell;
        const validations = restaurantConf.validations;
        const hint = ri.hint || "";
        const hintEn = ri.hintEn || "";
        const hintRu = ri.hintRu || "";
        const isPickupCooperation = !!ri.isPickupCooperation;
        const deliveryRegionName = ri.deliveryRegionName || ri.deliveryRegionName === "" ? ri.deliveryRegionName : ri?.deliveryRegionName || "";

        // Ensure mutation path exists so onChange handlers don't crash on incomplete data
        if (!this.restaurantDetails.restaurantInformation) this.restaurantDetails.restaurantInformation = {};
        if (!this.restaurantDetails.restaurantInformation.location) this.restaurantDetails.restaurantInformation.location = {};
        if (!this.restaurantDetails.restaurantInformation.location.coordinates) this.restaurantDetails.restaurantInformation.location.coordinates = { lat: "", lng: "" };
        if (!this.restaurantDetails.restaurantInformation.workingHours) this.restaurantDetails.restaurantInformation.workingHours = { start: "", end: "" };
        if (!this.restaurantDetails.restaurantInformation.holidays) this.restaurantDetails.restaurantInformation.holidays = { from: "", to: "" };
        if (!Array.isArray(this.restaurantDetails.restaurantInformation.phoneNumbers)) this.restaurantDetails.restaurantInformation.phoneNumbers = phoneNumbers.length ? phoneNumbers : [""];
        if (!Array.isArray(this.restaurantDetails.restaurantInformation.nonWorkingDays)) this.restaurantDetails.restaurantInformation.nonWorkingDays = nonWorkingDays;
        if (!this.restaurantDetails.cooperationType) this.restaurantDetails.cooperationType = {};

        return (
            <div>
                {this.renderName()}
                {this.renderNameEn()}
                {this.renderNameRu()}
                {this.renderId()}
                {this.renderNId()}
                {this.renderBranchId()}
                {this.renderLegalPersonName()}
                {this.renderLegalAddress()}
                {this.renderDirectorFullName()}
                {this.renderTaxpayerIdentificationNumber()}
                {this.renderBankName()}
                {this.renderAccountNumber()}
                {this.renderAahSaler()}
                {this.renderPassportRequires()}
                {this.renderEmail()}
                {this.renderType()}
                {/*{this.renderCooperationType()}*/}
                {this.renderInvoiceType()}
                {this.renderPrintHdm()}
                {this.renderTaxRegimeField()}
                {this.renderFiscalTextField("ՀԴՄ գրանցման համարը (CRN)", "crn")}
                {this.renderFiscalTextField("ՀԴՄ գործարանային համար (SN)", "sn")}
                {this.renderFiscalNumberField("ՀԴՄ բաժնի համար", "dep")}
                {this.renderFiscalNumberField("Գանձապահի համար", "cashierId")}
                {this.renderJksSection()}
                {this.renderHdmPicture()}
                {this.renderNotification()}
                {this.renderIsSupplerWeb()}
                {this.renderInvoiceIssuingType()}
                {this.renderIsPrintHdm()}
                {this.renderHintsForB2BService()}
                {this.renderContactsNotifications()}
                {this.renderPriceInNotification()}
                {/*{this.renderPayer()}*/}
                {this.renderPaymentPeriod()}
                {this.renderCooperationMethod()}
                {this.renderSourceOfIncome()}
                {this.renderPercentage()}
                {this.renderSendToSupplier()}
                {this.renderTransactionMethod()}
                {this.renderApplicableDeliveryTime()}
                {this.renderRestaurantPhoneNumbers(
                    "_restaurant_phone_",
                    "phoneNumbers",
                    phoneNumbers,
                    validations.phoneNumbers,
                    (e, index) => {
                        this.restaurantDetails.restaurantInformation.phoneNumbers[
                            index
                            ] = e.target.value;
                        this.forceUpdate();
                    },
                )}
                {this.renderDeliveryRegion(
                    "_delivery_region_",
                    "deliveryRegionName",
                    deliveryRegionName,
                    validations.deliveryRegionName,
                    (e) => {
                        this.restaurantDetails.restaurantInformation.deliveryRegionName =
                            e.target.value;
                        this.forceUpdate();
                    },
                )}
                {this.renderDeliveryRegions(
                    "_delivery_regions_",
                )}
                {(() => {
                    const restaurantInformation = this.restaurantDetails.restaurantInformation || {};
                    const districtValidations = {
                        required: false,
                        validations: {},
                        validationErrors: {},
                        disabled: true,
                    };

                    return (
                        <>
                            {this.renderRestaurantAddress(
                                "_restaurant_address_",
                                "address",
                                address,
                                validations.address,
                                (e) => {
                                    this.restaurantDetails.restaurantInformation.location.address =
                                        e.target.value;
                                    this.forceUpdate();
                                },
                            )}
                            {this.renderRestaurantRegion(
                                "_restaurant_region_",
                                "districtAddress",
                                restaurantInformation.regionName || null,
                                districtValidations,
                            )}
                            {this.renderRestaurantAddress(
                                "_restaurant_address_en",
                                "addressEn",
                                addressEn,
                                validations.address,
                                (e) => {
                                    this.restaurantDetails.restaurantInformation.location.addressEn =
                                        e.target.value;
                                    this.forceUpdate();
                                },
                            )}
                            {this.renderRestaurantRegion(
                                "_restaurant_region_en",
                                "districtAddressEn",
                                restaurantInformation.regionNameEn || null,
                                districtValidations,
                            )}
                            {this.renderRestaurantAddress(
                                "_restaurant_address_ru",
                                "addressRu",
                                addressRu,
                                validations.address,
                                (e) => {
                                    this.restaurantDetails.restaurantInformation.location.addressRu =
                                        e.target.value;
                                    this.forceUpdate();
                                },
                            )}
                            {this.renderRestaurantRegion(
                                "_restaurant_region_ru",
                                "districtAddressRu",
                                restaurantInformation.regionNameRu || null,
                                districtValidations,
                            )}
                        </>
                    );
                })()}
                {this.renderRestaurantAditionalHint(
                    "_restaurant_hint_",
                    "hint",
                    hint,
                    {},
                    (e) => {
                        this.restaurantDetails.restaurantInformation.hint =
                            e.target.value;
                        this.forceUpdate();
                    },
                )}
                {this.renderRestaurantAditionalHint(
                    "_restaurant_hint_en",
                    "hintEn",
                    hintEn,
                    {},
                    (e) => {
                        this.restaurantDetails.restaurantInformation.hintEn =
                            e.target.value;
                        this.forceUpdate();
                    },
                )}
                {this.renderRestaurantAditionalHint(
                    "_restaurant_hint_ru",
                    "hintRu",
                    hintRu,
                    {},
                    (e) => {
                        this.restaurantDetails.restaurantInformation.hintRu =
                            e.target.value;
                        this.forceUpdate();
                    },
                )}
                {this.renderCoordinates(
                    { lat: "coordinatesLat", lng: "coordinatesLng" },
                    coordinates,
                    {
                        lat: (e) => {
                            if (!this.restaurantDetails.restaurantInformation.location.coordinates) {
                                this.restaurantDetails.restaurantInformation.location.coordinates = {};
                            }
                            this.restaurantDetails.restaurantInformation.location.coordinates.lat =
                                e.target.value;
                            this.restaurantDetails.restaurantInformation.regionName = "";
                            this.restaurantDetails.restaurantInformation.regionNameEn = "";
                            this.restaurantDetails.restaurantInformation.regionNameRu = "";
                            this.forceUpdate();
                        },
                        lng: (e) => {
                            if (!this.restaurantDetails.restaurantInformation.location.coordinates) {
                                this.restaurantDetails.restaurantInformation.location.coordinates = {};
                            }
                            this.restaurantDetails.restaurantInformation.location.coordinates.lng =
                                e.target.value;
                            this.restaurantDetails.restaurantInformation.regionName = "";
                            this.restaurantDetails.restaurantInformation.regionNameEn = "";
                            this.restaurantDetails.restaurantInformation.regionNameRu = "";
                            this.forceUpdate();
                        },
                    },
                )}
                {this.renderWorkingHours(
                    { start: "workingHoursStart", end: "workingHoursEnd" },
                    workingHours,
                    {
                        start: (e) => {
                            if (!this.restaurantDetails.restaurantInformation.workingHours) {
                                this.restaurantDetails.restaurantInformation.workingHours = {};
                            }
                            this.restaurantDetails.restaurantInformation.workingHours.start =
                                e;
                            this.forceUpdate();
                        },
                        end: (e) => {
                            if (!this.restaurantDetails.restaurantInformation.workingHours) {
                                this.restaurantDetails.restaurantInformation.workingHours = {};
                            }
                            this.restaurantDetails.restaurantInformation.workingHours.end =
                                e;
                            this.forceUpdate();
                        },
                    },
                )}
                {this.renderHolidays(
                    { from: "holidaysFrom", to: "holidaysTo" },
                    holidays,
                    {
                        from: (e) => {
                            this.restaurantDetails.restaurantInformation.holidays.from =
                                e;
                            this.forceUpdate();
                        },
                        to: (e) => {
                            this.restaurantDetails.restaurantInformation.holidays.to =
                                e;
                            this.forceUpdate();
                        },
                    },
                )}
                {this.renderNonWorkingDays(nonWorkingDays, (e, index) => {
                    this.restaurantDetails.restaurantInformation.nonWorkingDays[
                        index
                        ] = e.target.checked;
                    this.forceUpdate();
                })}
                {this.renderFromBackEntrance(isFromBackEntrance, (e, index) => {
                    this.restaurantDetails.restaurantInformation.isFromBackEntrance =
                        e.target.checked;
                    this.forceUpdate();
                })}
                {this.renderIsPickupCooperation(
                    isPickupCooperation,
                    (e, index) => {
                        this.restaurantDetails.restaurantInformation.isPickupCooperation =
                            e.target.checked;
                        this.forceUpdate();
                    },
                )}
                {this.renderDistanceCalcDiscludedPartner(
                    distanceCalcExcludedPartner,
                    (e, index) => {
                        this.restaurantDetails.restaurantInformation.distanceCalcExcludedPartner =
                            e.target.checked;
                        this.forceUpdate();
                    },
                )}
                {this.renderSendToHaysell(isSendToHaysell, (e, index) => {
                    this.restaurantDetails.isSendToHaysell = e.target.checked;
                    this.forceUpdate();
                })}
                {isSendToHaysell &&
                    this.renderHaysellRegion(
                        "_haysell_region_",
                        "haysellRegion",
                        haysellRegion,
                        validations.haysellRegion,
                        (e, index) => {
                            if (
                                this.restaurantDetails.restaurantInformation
                                    .haysell
                            ) {
                                this.restaurantDetails.restaurantInformation.haysell.region =
                                    e.target.value;
                            } else {
                                this.restaurantDetails.restaurantInformation.haysell =
                                    {
                                        region: e.target.value,
                                    };
                            }
                            this.forceUpdate();
                        },
                    )}
                {isSendToHaysell && this.renderHaysellUrl()}
                {isSendToHaysell && this.renderHaysellToken()}
                {isSendToHaysell && this.renderHaysellProfileId()}
                {this.renderSupplierSystemIntegration(
                    this.restaurantDetails.isIntegrationSupplierSystem,
                    (e) => {
                        this.restaurantDetails.isIntegrationSupplierSystem =
                            e.target.checked;
                    },
                )}
                {this.renderDeliveryService(
                    {
                        isDeliveryServiceProvision:
                            "isDeliveryServiceProvision",
                        supplierDeliveryTariff: "supplierDeliveryTariff",
                        supplierDeliveryTariff2nd: "supplierDeliveryTariff2nd",
                        preparationAverageTime: "preparationAverageTime",
                        deliveryAverageTime: "deliveryAverageTime",
                        paymentOption: "paymentOption",
                    },
                    this.restaurantDetails,
                    {
                        isDeliveryServiceProvision: (e) => {
                            this.restaurantDetails.isDeliveryServiceProvision =
                                e.target.checked;
                        },
                        supplierDeliveryTariff: (e) => {
                            this.restaurantDetails.supplierDeliveryTariff =
                                Number(e.target.value);
                        },
                        supplierDeliveryTariff2nd: (e) => {
                            this.restaurantDetails.supplierDeliveryTariff2nd =
                                Number(e.target.value);
                        },
                        preparationAverageTime: (e) => {
                            this.restaurantDetails.preparationAverageTime =
                                Number(e.target.value);
                        },
                        deliveryAverageTime: (e) => {
                            this.restaurantDetails.deliveryAverageTime = Number(
                                e.target.value,
                            );
                        },
                        paymentOption: (e, id) => {
                            let paymentOptions =
                                this.restaurantDetails.paymentOption || [];

                            if (e.target.checked) {
                                paymentOptions.push(id);
                            } else {
                                paymentOptions = paymentOptions.filter(
                                    (option) => option !== id,
                                );
                            }
                            this.restaurantDetails.paymentOption =
                                paymentOptions;
                        },
                    },
                )}

                {this.renderCompany(
                    "_company_",
                    "company",
                    company,
                    validations.legalPersonName,
                    (option) => {
                        this.restaurantDetails.company = option.value;
                        this.forceUpdate();
                    },
                )}
                {this.renderProductManagement(
                    headOfficeProductManagement,
                    (e) => {
                        this.restaurantDetails.restaurantInformation.productManagement =
                            e.target.checked;
                        this.forceUpdate();
                    },
                )}
                {this.renderBranches()}
            </div>
        );
    }

    render() {
        const restaurant = this.props.restaurantDetails;
        if (!restaurant || !Object.keys(restaurant).length) {
            return null;
        }
        this.isNew = !restaurant._id;
        return (
            <React.Fragment>
                <Modal
                    dialogClassName="large-modal"
                    show={this.props.restaurantDetails.show}
                    onHide={this.cancel.bind(this)}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {translator.translate("_restaurant_details_")}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="scrollable modal-possition">
                        <Formsy
                            id="restaurant-details-form"
                            ref={this.setFormRef}
                            preventDefaultSubmit
                            noValidate
                            onValid={this.enableButton}
                            onInvalid={this.disableButton}
                            onValidSubmit={this.handleValidSubmit.bind(this)}
                        >
                            {this.renderModalBody()}
                        </Formsy>
                    </Modal.Body>
                    {this.renderFooter()}
                </Modal>
                {this.state.showBranchDetailsModal &&
                    this.renderBranchDetailsModal()}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        restaurantDetails: state.restaurantDetails,
        regions: state.regions,
    };
};

export default connect(mapStateToProps, {
    hideRestaurantModal,
    addRestaurantByApi,
    updateRestaurantByApi,
    deleteBranch,
})(RestaurantDetails);
